export default __webpack_public_path__ + "images/2bbeab54ba72598d528fd5b6703e6403-ShannonProfile.png";